var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    rx: 22,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 47.667H45.8333C47.85 47.667 49.5 46.017 49.5 44.0003V25.667H33C30.25 25.667 27.8484 27.1886 26.6017 29.4253",
    stroke: "#64247E",
    strokeWidth: 3.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6666 53.167C25.6666 56.2103 28.1233 58.667 31.1666 58.667H33C33 56.6503 34.65 55.0003 36.6666 55.0003C38.6833 55.0003 40.3333 56.6503 40.3333 58.667H47.6666C47.6666 56.6503 49.3166 55.0003 51.3333 55.0003C53.35 55.0003 55 56.6503 55 58.667H56.8333C59.8766 58.667 62.3333 56.2103 62.3333 53.167V47.667H56.8333C55.825 47.667 55 46.842 55 45.8337V40.3337C55 39.3253 55.825 38.5003 56.8333 38.5003H59.1983L56.0633 33.0187C55.4033 31.882 54.1933 31.167 52.8733 31.167H49.5V44.0003C49.5 46.017 47.85 47.667 45.8333 47.667H44",
    stroke: "#64247E",
    strokeWidth: 3.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6667 62.3333C38.6917 62.3333 40.3333 60.6917 40.3333 58.6667C40.3333 56.6416 38.6917 55 36.6667 55C34.6416 55 33 56.6416 33 58.6667C33 60.6917 34.6416 62.3333 36.6667 62.3333Z",
    stroke: "#64247E",
    strokeWidth: 3.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3334 62.3333C53.3585 62.3333 55.0001 60.6917 55.0001 58.6667C55.0001 56.6416 53.3585 55 51.3334 55C49.3084 55 47.6667 56.6416 47.6667 58.6667C47.6667 60.6917 49.3084 62.3333 51.3334 62.3333Z",
    stroke: "#64247E",
    strokeWidth: 3.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3333 44V47.6667H56.8333C55.825 47.6667 55 46.8417 55 45.8333V40.3333C55 39.325 55.825 38.5 56.8333 38.5H59.1983L62.3333 44Z",
    stroke: "#64247E",
    strokeWidth: 3.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6666 36.667H36.6666",
    stroke: "#64247E",
    strokeWidth: 3.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6666 42.167H33",
    stroke: "#64247E",
    strokeWidth: 3.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6666 47.667H29.3333",
    stroke: "#515151",
    strokeWidth: 3.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSent);
export default __webpack_public_path__ + "static/media/sent.f5ef919a51e952d6093983ab72a16d89.svg";
export { ForwardRef as ReactComponent };